interface BetaFeatureRowProps {
    feature: string;
    label?: string;
    disabled: boolean;
    onRemove: () => void;
}

// Every row listed here is, by construction, currently enabled for this
// practice (see PracticeBetaAccessSection - the list only ever contains
// GET /practices/feature-flags/:practiceId's enabled names), so the only
// action is removal - the row disappears from the list once the parent's
// refetch drops it. Button styled like the practice Users tab's per-row
// Remove action.
export function BetaFeatureRow({ feature, label, disabled, onRemove }: BetaFeatureRowProps) {
    return (
        <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-gray-100 last:border-b-0">
            <span className="min-w-0 truncate">
                <span className="text-sm font-medium text-gray-800 font-mono">{feature}</span>
                {label && <span className="ml-2 text-xs text-gray-400">{label}</span>}
            </span>
            <button
                type="button"
                aria-label={`Remove ${feature}`}
                disabled={disabled}
                onClick={onRemove}
                className="h-8 px-3 rounded-lg border border-gray-200 text-[12px] font-semibold text-gray-600 hover:bg-gray-50 hover:text-red-600 shrink-0 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Remove
            </button>
        </div>
    );
}
